// routes/courseSessionPath.ts
//
// The address of a course session opened at one step. A page outside the
// session (a module quiz's self-assessment pages, ORA-1068) sends the student
// back to the step it came from with `courseSessionStepPath`; the session's
// loader reads the target, re-reads that course and module, opens the step,
// and drops the query from the address (`courseSessionLoader`).

export const COURSE_SESSION_PATH = '/course/session';

export interface CourseSessionTarget {
  /** The course id or its slug. */
  courseKey: string;
  moduleId: string;
  stepId: string;
}

const PARAMS = { courseKey: 'course', moduleId: 'module', stepId: 'step' };

export const courseSessionStepPath = (target: CourseSessionTarget): string => {
  const search = new URLSearchParams({
    [PARAMS.courseKey]: target.courseKey,
    [PARAMS.moduleId]: target.moduleId,
    [PARAMS.stepId]: target.stepId,
  });

  return `${COURSE_SESSION_PATH}?${search.toString()}`;
};

/** The step a session address names; null unless it names all three ids. */
export const readCourseSessionTarget = (
  search: URLSearchParams
): CourseSessionTarget | null => {
  const courseKey = search.get(PARAMS.courseKey);
  const moduleId = search.get(PARAMS.moduleId);
  const stepId = search.get(PARAMS.stepId);

  return courseKey && moduleId && stepId
    ? { courseKey, moduleId, stepId }
    : null;
};
